import React from 'react';

import { IChunkModel } from '@common/models/Chunks/Chunk';

import LessonsLinkItem from '../../LinksSection/Item';

interface PropsType {
	chunkModel: IChunkModel;
}

function ChunkFile({ chunkModel }: PropsType) {
	if (!chunkModel.file?.url) {
		return null;
	}

	return (
		<LessonsLinkItem
			title={chunkModel.name}
			href={chunkModel.file?.url}
			download={`${chunkModel.file?.original_name || chunkModel.name}`}
		/>
	);
}

export default ChunkFile;
